import { combineReducers } from 'redux';
import settingsReducer from './settings/settingsReducer';
import bankAccountReducer from './bankAccounts/bankAccountReducer';
import loadingReducer from './loading/loadingReducer';
import userReducer from './user/userReducer';
import applicationReducer from './application/applicationReducer';
import commonReducer from './common/commonReducer';
import personReducer from './person/personReducer';
import plaidReducer from './plaid/plaidReducer';
import metalStreamReducer from './metalStream/metalStreamReducer';
import documentsReducer from './documents/documentsReducer';
import fundingReducer from './funding/fundingReducer';
import custodiansReducer from './custodians/custodiansReducer';
import iraFundingReducer from './iraFunding/iraFundingReducer';
import agreementReducer from './agreement/agreementReducer';
import fundingSourceReducer from './fundingsource/fundingSourceReducer';
import employmentStatusReducer from './employmentStatus/employmentStatusReducer';
import identificationVerificationReducer from './identificationVerification/identificationVerificationReducer';

export default combineReducers({
  settings: settingsReducer,
  bankAccount: bankAccountReducer,
  loading: loadingReducer,
  user: userReducer,
  application: applicationReducer,
  common: commonReducer,
  person: personReducer,
  plaid: plaidReducer,
  metalStream: metalStreamReducer,
  documents: documentsReducer,
  funding: fundingReducer,
  iraFunding: iraFundingReducer,
  custodians: custodiansReducer,
  agreement: agreementReducer,
  fundingsources: fundingSourceReducer,
  employmentStatusList: employmentStatusReducer,
  identificationVerification: identificationVerificationReducer,
});
